import {PersonCard} from '../Templates';

class Expertise {
    constructor() {
        this.minTeamSize = 8;
        this.teamlist = document.querySelector('.expertise + .page-footer .page-footer__list');
        this.viewAll = document.querySelector('.expertise + .page-footer .page-footer__list--link .cta');
        this.page = 1;
        this.init();
    }

    init() {
        this.events();
        this.loadnext();
    }

    events() {
        this.viewAll.addEventListener('click', () => {
            this.loadnext();
            // remove load more button when all results are displayed
            this.viewAll.style.visibility = "hidden";
        });

    }

    loadnext() {
        const expid = this.viewAll.dataset.expid;
        const url = `/expertise-api/get_people/${expid}/${this.page}`;

        fetch(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-requested-with': 'XMLHttpRequest'
                },
                method: 'GET',
            })
            .then(response => response.json())
            .then(data => {
                this.page++;
                this.teamlist.innerHTML += this.buildTeamList(data);
                if (this.teamlist.childElementCount < this.minTeamSize) {
                    this.viewAll.style.visibility = "hidden";
                }
            })

    }

    buildTeamList(json_data) {
        return json_data.map(data => PersonCard(data)).join('');
    }
}

export default Expertise;
